import template from './rating_method_search.html';
import tr from '../../lib/default-translator.js';

class RatingMethodSearchComponentViewModel {
    constructor(params) {
        this.params = params;

        this.rating_methods = ko_helper.safe_observableArray();
        this.selected_method = ko_helper.safe_observable(params.selected_method || '');
        this.search_string = ko.observable('');

        // Computed observable for dynamically updating the placeholder
        this.placeholder_text = ko.pureComputed(() => {
            return this.selected_method() != null ? this.selected_method().rating_method_name : tr("Search rating method...");
        });

        this.search_string.subscribe((val) => {
            this.updateData();
        });
    }

    async init() {
        await this.updateData();
    }

    async updateData() {
        let options = {
            table: 'v_rating_methods',
            schema: 'perfm_manage',
            limit: 10000,
            filter_join: 'OR',
            filter: []
        };

        if (this.search_string() && this.search_string() != '') {
            options.filter.push({
                field: 'rating_method_name',
                operand: 'ILIKE',
                value: `%${this.search_string()}%`,
            });

            let result = await Grape.fetches.getJSON('/api/record', options);
            if (result.status != 'ERROR')
                if (result.records != null)
                    this.rating_methods(result.records);
        }
        else
            this.rating_methods([]);
    }

    method_click(selected) {
        this.selected_method(selected);
        console.log('SELECTED Method:', this.selected_method());
        this.search_string('');
    }

    clear_selected_option() {
        this.selected_method(null);
        this.search_string('');
    }
}

export default {
    name: 'rating_method_search_component',
    viewModel: RatingMethodSearchComponentViewModel,
    module_type: 'ko',
    template: template,
    template_filename: 'translation/components/rating_method_search_component'
};
